import { api } from "@api/api";
import { ApiResponse } from "@shared/types";
import { Level } from "@modules/levels/types";

import { ListLevelsQueryFilters } from "./types";

export async function getLevelsService(filters?: ListLevelsQueryFilters): Promise<Level[]> {
  try {
    const { data } = await api.get<ApiResponse<Level>>(`v1/level_admin/`, {
      params: {
        page: filters?.page,
        page_size: filters?.perPage,
        search: filters?.search,
        ids: Array.isArray(filters?.ids) ? filters.ids.join(",") : undefined,
      },
    });
    return data.results;
  } catch (error) {
    console.error("Error fetching levels:", error);
    throw error;
  }
}
